import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class FirstLoaderEvent extends BasicTrackingEvent {
    public gameId: number;
    public firstLoaderVersion: string;
    public firstLoaderReferer: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.gameId = this.gameId;
        vars.var_1 = this.firstLoaderVersion;
        vars.var_data = this.firstLoaderReferer;

        return vars;
    }
}
